import React from "react";
import { Instagram } from "lucide-react";
import { gallery } from "../mock";

const Gallery = () => {
  return (
    <section className="bg-[#0B102D] py-4">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-1">
        {gallery.map((src, i) => (
          <a key={i} href="#" className="group relative aspect-square overflow-hidden">
            <img
              src={src}
              alt={`Salmons Brothers gallery ${i + 1}`}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <span className="absolute inset-0 bg-[#CD0008]/80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <Instagram className="text-white" size={26} />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
